import { render, staticRenderFns } from "./CellFollow.vue?vue&type=template&id=297e3e4c&scoped=true&"
import script from "./CellFollow.vue?vue&type=script&lang=js&"
export * from "./CellFollow.vue?vue&type=script&lang=js&"
import style0 from "./CellFollow.vue?vue&type=style&index=0&id=297e3e4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e3e4c",
  null
  
)

export default component.exports